import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VMenu,
    {
      attrs: {
        "offset-y": "",
        left: "",
        transition: "slide-y-transition",
        "close-on-content-click": false,
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function (ref) {
            var on = ref.on
            return [
              _c(
                VBtn,
                _vm._g({ staticClass: "elevation-2", attrs: { icon: "" } }, on),
                [
                  _c(
                    VAvatar,
                    {
                      class: _vm.userInfo.photoURL
                        ? "text-h5 white--text font-weight-bold"
                        : "",
                      attrs: { size: "40", color: "primary" },
                    },
                    [
                      _vm.userInfo.photoURL
                        ? _c(VImg, {
                            staticClass: "rounded-circle",
                            attrs: { contain: "", src: _vm.userInfo.photoURL },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.getUserInitials()))]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
    },
    [
      _c(
        VList,
        { attrs: { dense: "", nav: "" } },
        [
          _c(
            VListItem,
            [
              _c(
                VListItemIcon,
                [_c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-user")])],
                1
              ),
              _c(
                VListItemContent,
                [
                  _c(VListItemTitle, [
                    _vm._v(
                      _vm._s(
                        _vm.userInfo.displayName
                          ? _vm.userInfo.displayName
                          : _vm.userInfo.email
                      )
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VListItem,
            [
              _c(
                VListItemIcon,
                [_c(VIcon, { attrs: { small: "" } }, [_vm._v("mdi-at")])],
                1
              ),
              _c(
                VListItemContent,
                [
                  _c(VListItemTitle, [
                    _vm._v(_vm._s(_vm.userLogin.email)),
                  ]),
                ],
                1
              ),
              _c(
                VListItemIcon,
                { staticClass: "m-0" },
                [
                  _c(
                    VBtn,
                    { attrs: { icon: "" } },
                    [
                      _c(
                        VIcon,
                        {
                          attrs: { small: "" },
                          on: {
                            click: function ($event) {
                              return _vm.onCopy(_vm.userLogin.email)
                            },
                          },
                        },
                        [_vm._v(" icon-copy ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VListItem,
            [
              _c(
                VListItemIcon,
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-card-account-details"),
                  ]),
                ],
                1
              ),
              _c(
                VListItemContent,
                [
                  _c(
                    VListItemTitle,
                    [
                      _c("h6", [_vm._v("Roles")]),
                      _vm._l(_vm.getRoles(), function (item) {
                        return item.roles_user.length > 0
                          ? _c("div", [
                              _vm._v(_vm._s(item.name_i18n) + " "),
                              _c(
                                "ul",
                                _vm._l(item.roles_user, function (role) {
                                  return _c(
                                    "li",
                                    {
                                      staticStyle: { "font-weight": "normal" },
                                    },
                                    [_vm._v(_vm._s(role))]
                                  )
                                }),
                                0
                              ),
                            ])
                          : _vm._e()
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VListItem,
            [
              _c(
                VListItemIcon,
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-domain"),
                  ]),
                ],
                1
              ),
              _c(
                VListItemContent,
                [
                  _vm.domains_optional && _vm.domains_optional.length == 0
                    ? _c(VListItemTitle, [
                        _vm._v(_vm._s(_vm.getDomainUser())),
                      ])
                    : _vm._e(),
                  _c(
                    VListItemTitle,
                    [
                      _vm.domains_optional && _vm.domains_optional.length > 0
                        ? _c(VSelect, {
                            attrs: {
                              outlined: "",
                              small: "",
                              dense: "",
                              items: _vm.domains_optional,
                              "hide-details": "auto",
                            },
                            on: { change: _vm.onSelectDomain },
                            model: {
                              value: _vm.domain_actual,
                              callback: function ($$v) {
                                _vm.domain_actual = $$v
                              },
                              expression: "domain_actual",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.menu, function (item, index) {
            return _c(
              VListItem,
              {
                key: index,
                attrs: {
                  to: item.link,
                  exact: item.exact,
                  disabled: item.disabled,
                  link: "",
                },
              },
              [
                _c(
                  VListItemIcon,
                  [
                    _c(
                      VIcon,
                      {
                        class: { "grey--text": item.disabled },
                        attrs: { small: "" },
                      },
                      [_vm._v(_vm._s(item.icon))]
                    ),
                  ],
                  1
                ),
                _c(
                  VListItemContent,
                  [
                    _c(VListItemTitle, [
                      _vm._v(_vm._s(item.key ? _vm.$t(item.key) : item.text)),
                    ]),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(VDivider, { staticClass: "my-1" }),
          _c(
            VListItem,
            {
              on: {
                click: function ($event) {
                  return _vm.$router.push({
                    name: "profile",
                    params: { email: _vm.userEmail },
                  })
                },
              },
            },
            [
              _c(
                VListItemIcon,
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-account-box"),
                  ]),
                ],
                1
              ),
              _c(
                VListItemContent,
                [
                  _c(VListItemTitle, [
                    _vm._v(_vm._s(_vm.$t("menu.dp.my_profile"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VListItem,
            {
              on: {
                click: function ($event) {
                  return _vm.$router.push({ name: "help_main" })
                },
              },
            },
            [
              _c(
                VListItemIcon,
                [_c(VIcon, { attrs: { small: "" } }, [_vm._v("icon-help")])],
                1
              ),
              _c(
                VListItemContent,
                [_c(VListItemTitle, [_vm._v("Ayuda")])],
                1
              ),
            ],
            1
          ),
          _c(
            VListItem,
            { on: { click: _vm.onLogout } },
            [
              _c(
                VListItemIcon,
                [
                  _c(VIcon, { attrs: { small: "" } }, [
                    _vm._v("mdi-logout-variant"),
                  ]),
                ],
                1
              ),
              _c(
                VListItemContent,
                [
                  _c(VListItemTitle, [
                    _vm._v(_vm._s(_vm.$t("menu.logout"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }